import { ExternalFooterLink } from './ExternalLink';

export const PortalFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="fixed bottom-0 left-0 right-0 border-t-[1px] border-secondary-deep-blue-80 pt-2 bg-solid-deep-blue">
      <ExternalFooterLink className="inline-block mr-5 ml-5" link="https://www.stark.co.uk/terms-and-conditions/" linkText="Terms of Use" />
      <ExternalFooterLink className="inline-block" link="https://www.stark.co.uk/company-policies/" linkText="Privacy Policy" />
      <span className="ml-10 text-sm">© Stark {currentYear}</span>
    </div>
  );
};
